export const Overlay = () => (
    <div className="absolute top-0 right-0 left-0 bottom-0 bg-card-overlay-pattern pointer-events-none"></div>
)
